module.exports = __webpack_public_path__ + "img/44.72ed288f.jpg";